// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './TimeTile.scss'
import classnames from 'classnames'
import { transformTimeToAmPm } from '../../helper'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const TimeTile = ({ timeValue, setIsSelected, isSelected, className = '', style = {} }) => (
  <div
    role='presentation'
    className={classnames(`time-tile-main-wrapper`, { isSelected }, className)}
    style={style}
    onClick={() => {
      setIsSelected(timeValue)
    }}>
    {transformTimeToAmPm(timeValue)}
  </div>
)
